import { render, staticRenderFns } from "./OAMessageUI.vue?vue&type=template&id=0fabf08e&scoped=true&"
import script from "./OAMessageUI.vue?vue&type=script&lang=js&"
export * from "./OAMessageUI.vue?vue&type=script&lang=js&"
import style0 from "./OAMessageUI.vue?vue&type=style&index=0&id=0fabf08e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fabf08e",
  null
  
)

export default component.exports